module.exports = __webpack_public_path__ + "it.svg?5a3412cbe8f690dc5dfc92c3b8b68001";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/it.svg
// module id = 1173
// module chunks = 0